<template>
  <BaseCenteredModal
    v-model:is-modal-open="localIsModalOpen"
    :title="titleNoteForm"
    size="large"
  >
    <template #body>
      <div class="flex w-full flex-col gap-3">
        <div class="flex flex-col gap-4 pt-1">
          <div class="grid-form items-end">
            <span class="block w-full">
              <BaseSimpleDatePicker
                :key="cNoteDate"
                :label="$t('attributes.date')"
                :defaultValue="cNoteDate"
                :disabled="false"
                :required="true"
                name="date"
                :errors="errors.date"
                @change="getInputValue"
              />
            </span>

            <span class="block w-full">
              <BaseTimeInput
                :key="note.time"
                :label="$t('attributes.hour')"
                placeholder="00:00"
                name="time"
                required="true"
                :value="note.time"
                :errors="errors.time"
                :get-input-value="getInputValue"
              />
            </span>
          </div>

          <BaseInput
            :label="$t('attributes.title')"
            :placeholder="$t('attributes.title')"
            name="title"
            :required="true"
            v-model="note.title"
            :errors="errors.title"
          />

          <BaseSelectSimpleAjax
            :key="note"
            url="api/work-for-select"
            :label="$t('global.work')"
            name="work_id"
            v-model="note.work_id"
            trackBy="id"
            attributeLabel="title"
            :errors="errors.work_id"
            :default-ajax="computedWork"
            @setSelected="getInputValue"
          />

          <BaseSelectSimple
            :v-if="metadata.note_types"
            :key="note.type"
            :label="$t('attributes.type')"
            :placeholder="$t('attributes.type')"
            name="type"
            :options="metadata.note_types"
            :defaultValue="
              this.metadata.note_types.find((type) => type.id === note.type)
            "
            :errors="errors.type"
            :required="true"
            @setSelected="getInputValue"
          />
          <!--          -->
          <BaseWysiwyg
            :label="$t('attributes.description')"
            v-model="note.description"
            :value="note.description"
            name="description"
            :required="true"
            :errors="errors.description"
            @change.self="getInputValue"
          />
          <!--          -->
        </div>
      </div>
    </template>
    <template #footer>
      <BaseButton
        color="primary"
        icon="paper-plane"
        :title="buttonText"
        @click="submitNote"
      />
      <BaseButton :title="$t('button.close')" color="dark" @click="close" />
    </template>
  </BaseCenteredModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'
import moment from 'moment'

export default {
  name: 'NoteFormDialog',
  components: { BaseCenteredModal },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    note_load_id: {
      required: false
    }
  },
  data() {
    return {
      editor: null
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/getAuth',
      note: 'note/getNote',
      metadata: 'note/getNoteMetadata',
      errors: 'auth/getErrors'
    }),
    localIsModalOpen: {
      get() {
        return this.isOpen
      },
      set(value) {
        if (!value) this.close()
      }
    },
    cNoteDate() {
      return this.note.date
        ? new Date(moment(this.note.date, 'DD/MM/YYYY'))
        : null
    },
    buttonText() {
      if (isNaN(this.note_load_id)) {
        return this.$t('button.add', { var: '' })
      }
      return this.$t('button.edit', { var: '' })
    },
    titleNoteForm() {
      if (isNaN(this.note_load_id)) {
        return this.$t('global.add_note')
      }
      return this.$t('button.edit', { var: this.$t('global.note') })
    },
    computedWork() {
      return this.note && this.note.work_id && this.note.work
        ? {
            id: this.note.work_id,
            title: this.note.work.reference
              ? `${this.note.work.title} (${this.note.work.reference})`
              : this.note.work.title
          }
        : {}
    }
  },
  methods: {
    ...mapActions({
      fetchNewNote: 'note/fetchNewNote',
      fetchNoteById: 'note/fetchNoteById',
      addNote: 'note/storeNote',
      editNote: 'note/updateNote'
    }),
    getInputValue({ attribute, value }) {
      this.note[attribute] = value
    },
    submitNote() {
      if (!isNaN(this.note_load_id)) {
        this.editNote({ note: this.note }).then(this.close)
      } else {
        this.note.reporter_id = this.auth.id
        this.addNote({ note: this.note }).then(this.close)
      }
    },
    close() {
      this.$emit('close')
    }
  },
  watch: {
    isOpen(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        if (!isNaN(this.note_load_id)) {
          this.fetchNoteById({ id: this.note_load_id })
        } else {
          this.fetchNewNote()
        }
      }
    }
  }
}
</script>
